$(document).ready(function(){
  
$(".note.note--success").closest(".modal__inner").addClass("success_popup");
	 
});



$(document).ready(function(){
	
$('.banner-slider-area').slick({
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  $('.s-rebel-reviews-slider').slick({
  dots: false,
  arrows: true,
  prevArrow: $('.prev'),
  nextArrow: $('.next'),
  infinite: true,
  // autoplay: true,
  speed: 600,
  slidesToShow: 2,
  slidesToScroll: 2,
  
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

});

$(document).ready(function(){
  $('.featured-collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    infinite: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

$(document).ready(function(){
$(document).on("click",".tab-buttons a",function(){
  var id_tab=$(this).attr("data-val");
  $(".tab-buttons a").removeClass("active");
  $(this).addClass("active");
  
  $(".product-tab-body").removeClass("active");
  $(".product-tab-body."+id_tab).addClass("active");
});
});


// Read More read less JS

$(document).ready(function () {
  $('.review-box').each(function () {
    const $content = $(this).find('.common-content');
    const $readMoreBtn = $(this).find('.review-read-more');

    // Temporarily remove max-height to measure actual content height
    const originalMaxHeight = $content.css('max-height');
    $content.css('max-height', 'none');
    const contentHeight = $content.outerHeight(); // Get full content height
    $content.css('max-height', originalMaxHeight); // Reset max-height

    // Show "Read More" only if the content exceeds 150px
    if (contentHeight <= 87) {
      $readMoreBtn.hide(); // Hide the button if the content fits
    }
  });

  $('.review-read-more').on('click', function () {
    const $content = $(this).closest('.review-content').find('.s-review-content');

    // Toggle the expanded class
    $content.toggleClass('expanded');

    // Change the button text based on the current state
    if ($content.hasClass('expanded')) {
      $(this).text('Read Less');
    } else {
      $(this).text('Read More');
    }
  });
});

// scroll JS

$(document).ready(function () {
  $(".product-info-tab-area .tab-btn").on("click", function () {
    // Remove active class from all buttons inside the product-info-tab-area
    $(".product-info-tab-area .tab-btn").removeClass("scroll-left");
    $(this).addClass("scroll-left");

    // Scroll the clicked button into view
    const container = $(".product-info-tab-area .tab-buttons");
    const buttonOffset = $(this).offset().left;
    const containerOffset = container.offset().left;
    const containerScroll = container.scrollLeft();
    const scrollAmount = buttonOffset - containerOffset + containerScroll;

    container.animate(
      {
        scrollLeft: scrollAmount,
      },
      300 // Duration in milliseconds
    );
  });
});



